
import router from "@/router";
import { defineComponent } from "@vue/runtime-core";
import { RollbackOutlined } from "@ant-design/icons-vue";

export default defineComponent({
  components: {
    RollbackOutlined,
  },
  setup() {
    const goBack = () => router.push("/dashboard");

    return {
      goBack,
    };
  },
});
